import { PublicLayout } from "@/components/layout/PublicLayout";
import { FloatingCard } from "@/components/primitives/FloatingCard";

export default function Impressum() {
	return (
		<PublicLayout>
			<article className="mx-auto w-full max-w-2xl px-4 py-8">
				<FloatingCard className="p-6 sm:p-8">
				<h1 className="text-2xl font-semibold tracking-tight">Impressum</h1>
				<p className="mt-3 text-sm text-fg-muted">
					Kartenwerk ist ein Produkt von{" "}
					<a
						href="https://mattschach.com"
						target="_blank"
						rel="noopener noreferrer"
						className="text-teal-500 hover:text-teal-400"
					>
						mattschach.com
					</a>
					.
				</p>

				<section className="mt-10 space-y-3">
					<h2 className="text-xl font-semibold tracking-tight">Angaben gemäß § 5 TMG</h2>
					<p className="text-fg-muted">
						Alexander Abelt
						<br />
						Kettenburg 14
						<br />
						27374 Visselhövede
					</p>
				</section>

				<section className="mt-10 space-y-3">
					<h2 className="text-xl font-semibold tracking-tight">Kontakt</h2>
					<p className="text-fg-muted">
						Telefon: 04262 / 790 15 99
						<br />
						E-Mail:{" "}
						<a
							href="mailto:impressum@mattschach.com"
							className="text-teal-500 hover:text-teal-400"
						>
							impressum@mattschach.com
						</a>
					</p>
				</section>

				<section className="mt-10 space-y-3">
					<h2 className="text-xl font-semibold tracking-tight">Umsatzsteuer-ID</h2>
					<p className="text-fg-muted">
						Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
						<br />
						DE293339357
					</p>
				</section>

				<section className="mt-10 space-y-3">
					<h2 className="text-xl font-semibold tracking-tight">Redaktionell Verantwortlicher</h2>
					<p className="text-fg-muted">
						Alexander Abelt
						<br />
						Kettenburg 14
						<br />
						27374 Visselhövede
					</p>
				</section>

				<section className="mt-10 space-y-3">
					<h2 className="text-xl font-semibold tracking-tight">EU-Streitschlichtung</h2>
					<p className="text-fg-muted">
						Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
						bereit:{" "}
						<a
							href="https://ec.europa.eu/consumers/odr/"
							target="_blank"
							rel="noopener noreferrer"
							className="text-teal-500 hover:text-teal-400"
						>
							https://ec.europa.eu/consumers/odr/
						</a>
						.
						<br />
						Unsere E-Mail-Adresse finden Sie oben im Impressum.
					</p>
				</section>

				<section className="mt-10 space-y-3">
					<h2 className="text-xl font-semibold tracking-tight">
						Verbraucherstreitbeilegung / Universalschlichtungsstelle
					</h2>
					<p className="text-fg-muted">
						Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
						Verbraucherschlichtungsstelle teilzunehmen.
					</p>
				</section>

				<section className="mt-10 space-y-3">
					<h2 className="text-xl font-semibold tracking-tight">Haftung für Inhalte</h2>
					<p className="text-fg-muted">
						Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen
						Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir
						als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
						fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
						rechtswidrige Tätigkeit hinweisen.
					</p>
					<p className="text-fg-muted">
						Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
						allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist
						jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
						Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte
						umgehend entfernen.
					</p>
				</section>

				<section className="mt-10 space-y-3">
					<h2 className="text-xl font-semibold tracking-tight">Haftung für Links</h2>
					<p className="text-fg-muted">
						Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
						keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
						Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
						Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum
						Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
						Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
					</p>
					<p className="text-fg-muted">
						Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
						konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
						Rechtsverletzungen werden wir derartige Links umgehend entfernen.
					</p>
				</section>

				<section className="mt-10 space-y-3">
					<h2 className="text-xl font-semibold tracking-tight">Urheberrecht</h2>
					<p className="text-fg-muted">
						Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
						unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
						Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
						bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
						Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen
						Gebrauch gestattet.
					</p>
					<p className="text-fg-muted">
						Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
						Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
						gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam
						werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
						Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
					</p>
				</section>
				</FloatingCard>
			</article>
		</PublicLayout>
	);
}
